/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpsertClassroomDisciplineLangViewModel } from "../types/UpsertClassroomDisciplineLangViewModel.ts";

export const upsertClassroomDisciplineLangViewModelSchema = z.object({
  cultureInfo: z.string().nullish(),
  description: z.string().nullish(),
  instruction: z.string().nullish(),
}) as unknown as ToZod<UpsertClassroomDisciplineLangViewModel>;
